module.exports = __webpack_public_path__ + "static/media/calc_sc.d9250f9a.ico";